module.exports = __webpack_public_path__ + "static/3-960a9a32dba8a4deeba3a9738711b433.jpg";